/**
 * MessageList 의 "끝 근처" 판정 helper.
 *
 * 과거 버전: useAutoScroll hook + ResizeObserver delta 기반 scroll 보전 + wasNearBottom
 * scroll listener 추적 — 입력창 grow / streaming chunk / 메시지 추가 등 trigger 별로
 * timing 어긋남이 발생해 마지막 메시지가 입력창 뒤로 가려지는 회귀가 반복 발생.
 *
 * 현재 (Final): `.chat-message-list` 가 `display:flex; flex-direction:column-reverse;` —
 * 브라우저 native scroll-anchoring 이 모든 layout 변동에서 visual bottom 메시지 위치 자동
 * 유지. 별도 scroll 보정 hook 불필요. 본 모듈은 "최신 메시지로 이동" 화살표 노출 판정
 * 용도의 `isNearBottom` 만 export.
 *
 * column-reverse 컨테이너: scrollTop = 0 이 visual bottom, 양수면 위로 스크롤 상태.
 */

const DEFAULT_THRESHOLD = 200;

export function isNearBottom(el: HTMLElement | null, threshold = DEFAULT_THRESHOLD): boolean {
  if (!el) return true;
  return el.scrollTop <= threshold;
}
